import type { FileRecord } from "@k3-tech/react-kit";

// image_type is the source of truth: a cleared custom image leaves its old URL on the row.
export const resolveMenuImageType = (
	uploadedURL: string | undefined,
): "custom" | "inherit" => (uploadedURL ? "custom" : "inherit");

// Only a custom row owns its image, so an inherited row must not show a stale URL back.
export const resolveMenuImagePrefill = (row: {
	imageType: string;
	externalImageURL: string;
}): FileRecord[] => {
	const url = row.imageType === "custom" ? row.externalImageURL : "";
	return url
		? [
				{
					url,
					thumbnailUrl: url,
					name: "menu-image",
					status: "success" as const,
				},
			]
		: [];
};

// Mirrors the backend fallback so the admin list shows the image the channel actually receives:
// a custom image, otherwise the product image. The sales channel default is applied backend-side.
export const resolveMenuImagePreview = (row: {
	imageType: string;
	externalImageURL: string;
	product?: { mainImageFileMediumPathURL?: string | null } | null;
}): string =>
	row.imageType === "custom"
		? row.externalImageURL
		: (row.product?.mainImageFileMediumPathURL ?? "");
